<template>
  <v-select
    v-model="profile"
    :items="profiles"
    :menu-props="{ closeOnContentClick: true }"
    label="Profile"
  >
    <template v-slot:selection="{ item }">
      {{ item.firstName }} {{ item.lastName }}
    </template>
    <template v-slot:item="{ item }">
      <v-list-item @click="select(item)">
        <v-list-item-avatar class="dark-background text-center">
          <v-img v-if="item.picture" :src="item.picture"></v-img>
          <span class="white--text subtitle-2 ml-2">
            {{ item.firstName.substring(0, 1) }}
            {{ item.lastName.substring(0, 1) }}
          </span>
        </v-list-item-avatar>
        <v-list-item-title>
          {{ item.firstName }} {{ item.lastName }}
        </v-list-item-title>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SelectProfile",
  data() {
    return {
      profile: {},
    };
  },
  computed: {
    ...mapGetters({
      profiles: "profiles/getProfiles",
    }),
  },
  methods: {
    ...mapActions({
      listProfiles: "profiles/listProfiles",
    }),
    select(item) {
      this.profile = item;
      this.$emit("select", item);
    },
  },
  async mounted() {
    await this.listProfiles();
    if (this.profiles.length > 0) {
      this.select(this.profiles[0]);
    }
  }
};
</script>
